export default __webpack_public_path__ + "9323ebc91e5e5a381fa3d6fdc9d1ea0f.woff";